// extracted by mini-css-extract-plugin
export default {"wrapper":"SongCard_wrapper__u9k+i","imageDiv":"SongCard_imageDiv__HdZxF"};